export enum StorageType {
    ROW= "row",
    COLUMN = "column",
    LAYER = "layer",
}

export interface StorageTypeDescription {
    readonly id: string
    readonly name: string
}

export const StorageTypes: { [key: string]: StorageTypeDescription } = {};
StorageTypes[StorageType.ROW] = {id: StorageType.ROW, name: "库区"};
StorageTypes[StorageType.COLUMN] = {id: StorageType.COLUMN, name: "库位"};
StorageTypes[StorageType.LAYER] = {id: StorageType.LAYER, name: "仓位"};

export function getStorageTypeName(typeId: string) {
    const storageType = StorageTypes[typeId];
    return storageType?.name || "";
}

export function getStorageType(storageType: string) {
    if (storageType === StorageType.ROW.toLocaleUpperCase()){
      return StorageType.ROW;
    }
    if (storageType === StorageType.COLUMN.toLocaleUpperCase()){
      return StorageType.COLUMN;
    }
    if (storageType === StorageType.LAYER.toLocaleUpperCase()){
      return StorageType.LAYER;
    }
    return "";
}